import { Routes } from '@angular/router';
import { IndexComponent } from './app/pages/index/index.component';
import { AppManagementLayout } from './app/layout/component/management.layout';
import { LoginComponent } from './app/pages/login/login.component';
import { NotFoundComponent } from './app/pages/notfound/notfound.component';
import { AuthGuard } from '@/helper/guards/auth.guard';

export const appRoutes: Routes = [
    {
        path: '',
        component: IndexComponent,
        data: { title: 'footer.title' }
    },

    {
        path: 'login',
        component: LoginComponent,
        data: { title: 'auth.login' }
    },

    {
        path: 'admin',
        component: AppManagementLayout,
        loadChildren: () => import('./app/modules/management/management.routes'),
        canActivate: [AuthGuard]
    },
    {
        path: 'notfound',
        component: NotFoundComponent,
        data: { title: 'common.pageNotFound' }
    },
    { path: '**', redirectTo: '/notfound' }
];
